import { Header } from '@10d/tend-ui-header';
import { Layout as TendLayout } from '@10d/tend-ui-primitives';
import { colors } from '@10d/tend-ui-tokens/global/colors';
import { useHistory } from 'react-router-dom';
import React, { FC, useContext, useEffect } from 'react';
import { logout } from 'samolet-oauth2';

import { useMenu, useSelectedV2 } from './hooks';
import { useAppSelector } from 'hooks';

import { ANALYTICS } from 'consts';
import { MENU_ITEMS } from 'consts/menu';

import { appendFeedbackScript, getCookie } from 'utils';
import { isStage } from 'helpers';

import { UserContext } from 'context/UserContext';
import { post } from '../api/requests';
import { captureException } from '@sentry/react';
import { Toast } from '@10d/tend-ui/primitives';

const isAuthSession = __USE_AUTH_TYPE__ === 'SESSION';

export const Layout: FC<Props> = ({ children }) => {
  const profile = useContext(UserContext);
  const history = useHistory();
  const { role, username, firstName, lastName, email } = profile;

  useEffect(() => {
    appendFeedbackScript(username);
  }, [role, username]);

  // @ts-ignore
  // TODO UI type bad
  const menu = useMenu(profile, MENU_ITEMS);
  const { push } = useHistory();
  const selected = useSelectedV2();

  const { version } = useAppSelector(state => state.stand.stand);

  const handleClick = (path: string[]) => {
    push(path[0]);
  };

  const onLogout = async () => {
    try {
      if (!isAuthSession) return null;

      const formData = new FormData();
      const csrfToken = getCookie('csrftoken');

      if (csrfToken) {
        formData.append('csrfmiddlewaretoken', csrfToken);
      }

      await post('api/session/logout/', formData, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'multipart/form-data',
        },
      });

      history.push('/auth');
    } catch (error) {
      captureException(error);
      Toast.error({
        message: 'Ошибка выхода',
      });
    }
  };

  return (
    <TendLayout.Root>
      <Header
        app='s.home'
        stand={isStage ? 'stage' : 'prod'}
        user={{
          username: username || '',
          firstName: firstName || '',
          lastName: lastName || '',
          email: email || '',
          role: role || '',
        }}
        profile={{
          items: defaultItems => {
            const items = defaultItems.map(item =>
              item.key === 'profile-menu-item-logout'
                ? { ...item, onClick: () => (isAuthSession ? onLogout() : logout()) }
                : item,
            );
            return version
              ? items.concat([
                  {
                    key: 'version',
                    label: (
                      <>
                        <div style={{ color: colors.gray400 }}>Версия:</div>
                        <div style={{ color: colors.gray200 }}>{version}</div>
                      </>
                    ),
                  },
                ])
              : items;
          },
        }}
        navigation={{
          selectedKeys: [selected],
          defaultSelectedKeys: [ANALYTICS],
          items: menu,
          onSelect: handleClick,
        }}
      />
      <TendLayout.Main>{children}</TendLayout.Main>
    </TendLayout.Root>
  );
};

type Props = {
  children: React.ReactNode;
};
